// pages/publicTabs/GcuAcceptation.jsx

import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';

function GcuAcceptation({ documentName = 'GCU', onVersionNumberFetched }) {
  const STYLE_ID = `style-${documentName}`;
  const publicContainerRef = useRef(null);
  const [publicContent, setPublicContent] = useState('');

  useEffect(() => {
    const fetchPublicContent = async () => {
      try {
        const response = await axios.get(
          '/api/admin/lexical/retrieve-public-html-document',
          { params: { documentName } }
        );

        const payload = response.data || {};
        const data = payload.data || {};

        const { htmlContent, cssPublic, contentHash } = data;
        const { versionNumber } = payload;

        if (htmlContent) setPublicContent(htmlContent);
        if (versionNumber && onVersionNumberFetched) onVersionNumberFetched(versionNumber);

        let styleEl = document.getElementById(STYLE_ID);
        const prevHash = styleEl?.getAttribute('data-hash') || null;

        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.id = STYLE_ID;

          const meta = document.querySelector('meta[name="csp-nonce"]');
          const nonce = meta && meta.content;
          if (nonce) styleEl.setAttribute('nonce', nonce);

          document.head.appendChild(styleEl);
        }

        if (contentHash && contentHash !== prevHash) {
          styleEl.textContent = cssPublic || '';
          styleEl.setAttribute('data-hash', contentHash);
        }

      } catch (error) {
        console.error('Failed to fetch public content:', error);
      }
    };

    fetchPublicContent();
  }, [documentName, onVersionNumberFetched]);

  const trustedHTML = useMemo(() => {
    if (window.trustedTypes) {
      try {
        const policy = window.trustedTypes.createPolicy('pallasPages', {
          createHTML: i => i,
          createScript: i => i,
          createScriptURL: i => i
        });
        return policy.createHTML(publicContent);
      } catch {
        return window.trustedTypes.createPolicy('pallasPages').createHTML(publicContent);
      }
    }
    return publicContent;
  }, [publicContent]);

  return (
    <div className="public-container margin-bottom-spacer">
      <div
        ref={publicContainerRef}
        className="public-rte-content-container lexical-rendered-content"
        data-doc={documentName}
        role="document"
        dangerouslySetInnerHTML={{ __html: trustedHTML }}
      />
    </div>
  );
}

export default GcuAcceptation;
